import { useContext, useEffect, useState } from "react";
import { PlansTable } from "../plans/plans-table";
import FreeClientFormContext from "./free-client-form-context";
import { clientConfig } from "../../awsClientConfig";
import { UpdateEnrollmentProtectionPlan } from "../../queries/UpdateEnrollmentProtectionPlan";
import useEnrollmentStore from "../../store/EnrollmentStore";
import { GetProtectionPlans } from "../../queries/GetProtectionPlans";
import { Box, Button } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { FeatureFlags } from "../../types/featureFlags";
import { useFlags } from "launchdarkly-react-client-sdk";

const ProtectionPlanPrice = () => {

    const {enrollmentId, SetFinalPlan, next, recommandedPlan, unavailableProtectionPlan, previous,finalPlan} = useContext(FreeClientFormContext);

    const { setProtectionPlanEnrollment } = useEnrollmentStore();
    const [plans, setPlans] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const flagList: FeatureFlags = useFlags();
    const client = new clientConfig();

    useEffect(() => {
        fetchPlans();
    }, []);

  useEffect(() => {
    if (flagList && !isLoading) {
      setPlans((prevPlans) =>
        prevPlans.filter((planInfo: any) => {
          if (planInfo.Name === 'Free') return flagList?.featureRetailFreePlan;
          return true;
        })
      );
    }
  }, [flagList, isLoading]);

  const fetchPlans = async () => {
        client
        .query({
            query: GetProtectionPlans,
        })
        .then((res: any) => {
            if(res.data.GetProtectionPlans){
              setPlans(res.data.GetProtectionPlans.filter((planInfo: any) => {
                  if (planInfo.Name === 'ProtectionPartnerMonitoring') return false;
                  if (planInfo.Name === 'Free') return flagList?.featureRetailFreePlan;
                  return true;
                })
              );
            setIsLoading(false);
            }
            
        })
        .catch((error: any) => {
            console.log(error, "error");
        });
    };


    const onPlanSelectHandler = (plan: any) => {
    const variables = {
        EnrollmentId: enrollmentId,
        ProtectionPlanId: plan?.Id,
    };

    client
        .mutate({
        mutation: UpdateEnrollmentProtectionPlan,
        variables: variables,
        }).then((res: any) => {
            if (res.data.UpdateEnrollmentProtectionPlan) {
                setProtectionPlanEnrollment({
                subscriptionPlan: plan.Name,
                subscriptionStatus: '',
                enrollmentStatus: ''
                });
                SetFinalPlan(plan);
                next();
            }
        }).catch((error: any) => {
        });
    };

    return (
        <Box sx={{alignItems: 'flex-center',
            p: { xs: 2, md: 6, lg: 4 },
            m: { xs: 2, md: 6, lg: 4 }}}>
            <Box sx={{
                alignItems: 'flex-center',
                pl: { xs: 2, md: 6, lg: 4 },
                pr: { xs: 2, md: 6, lg: 4 }
                }}>
                <Button variant="text" sx={{color: '#212636', p:0}} onClick={previous}> <ArrowBack fontSize='small'/> Back</Button>
            </Box> 
            <PlansTable onPlanSelect={onPlanSelectHandler} 
                plans={plans} 
                recommandedPlan={recommandedPlan} 
                unavailableProtectionPlan={unavailableProtectionPlan}
                selectedPlan={finalPlan?.Name}
                />
        </Box>
    )
}

export default ProtectionPlanPrice;